import React from "react";
import Navbar from "./Navbar";
import BookingFooter from "./BookingFooter";
import { Outlet, useLocation } from "react-router-dom";

export default function Layout() {
  const location = useLocation();
  const hideFooter = location.pathname === "/login" || location.pathname === "/register";

  return (
    <div className="layout">
      <Navbar />
      <main style={{ minHeight: "80vh" }}>
        <Outlet />
      </main>
      {!hideFooter && <BookingFooter />}
    </div>
  );
}
